import { useState } from "react";
import * as dateFNS from 'date-fns';
import { FORM_FIELD, PAYMENT_METHOD } from "../constants";
import { producaov2 } from "../../../../services/apis";
import { validateValues } from "../utils";

export default function useProductExtension() {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [values, setValues] = useState({
    [FORM_FIELD.MAX_INSTALLMENTS]: 1,
    [FORM_FIELD.PAYMENT_METHOD]: PAYMENT_METHOD.ALL,
    [FORM_FIELD.EXPIRATION_DATE]: dateFNS.format(
      dateFNS.endOfToday(),
      "yyyy-MM-dd HH:mm"
    ),
  });
  const [formErrors, setFormErrors] = useState({});
  const [linkInformation, setLinkInformation] = useState({});

  const onClearLinkInformation = () => {
    setLinkInformation({});
  }

  const onChangeValue = (key, value) => {
    if(linkInformation) {
      onClearLinkInformation();
    }

    if(formErrors[key]) {
      setFormErrors(prev => ({...prev, [key]: null}))
    }

    setValues((prev) => ({ ...prev, [key]: value }));
  };

  const onSubmit = async () => {
    const formError = validateValues(values);

    if(formError.hasError) {
      setFormErrors(formError.errors);
      return;
    }

    setLoadingSubmit(true);

    try {
      const response = await producaov2.post('/admin/product/extension-link', {
        type: values[FORM_FIELD.LINK_TYPE],
        userID: values[FORM_FIELD.USER_ID],
        courseID: values[FORM_FIELD.PRODUCT_ID],
        extension_days: values[FORM_FIELD.EXTENSION_DAYS],
        total: values[FORM_FIELD.TOTAL],
        maxInstallments: values[FORM_FIELD.MAX_INSTALLMENTS],
        payment_method: values[FORM_FIELD.PAYMENT_METHOD],
        link_expiration_date: values[FORM_FIELD.EXPIRATION_DATE],
        cycles: values[FORM_FIELD.CYCLES],
        cyclePrice: values[FORM_FIELD.CYCLE_PRICE],
        is_lifetime: values[FORM_FIELD.IS_LIFETIME]
      }, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
        }
      });

      setLinkInformation({
        link: response.data.link
      });
    } catch(error) {
      console.log(error);
    } finally {
      setLoadingSubmit(false);
    }
  }

  return {
    values,
    formErrors,
    loadingSubmit,
    linkInformation,
    onChangeValue,
    onSubmit,
    onClearLinkInformation
  };
}
